import type { Cascadify } from './util'
import type { Media } from './media'

export enum ActivityMediaType {
  Background = 'background',
  Preview = 'preview',
  Thumbnail = 'thumbnail',
}

export type ActivityMediaSettings = {
  /** Integer value in 1-100 range  */
  opacity?: number
}

export type RootActivityMedia = {
  id: number
  type: ActivityMediaType
  settings: ActivityMediaSettings
  mediaId: number
}

export type ActivityMedia = RootActivityMedia & {
  activityId: number
  media: Media
}

export type CascadeActivityMedia = Cascadify<RootActivityMedia> & {
  activityId?: number
  media: Media
}

export type ActivityMediaId = ActivityMedia['id']
